import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=a3bf3d34&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=a3bf3d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf3d34",
  null
  
)

export default component.exports